const e=e=>"number"==typeof e;export{e as isNumber};
